import {DRVBundGlobals} from '@zs21/drv-bund-common-ilias-utils';
import $ from 'jquery';
import {ENV_VARS} from '../envVars';

const CODE_LINK_TABLE_URI = ENV_VARS.VOUCHER_DATATABLE_URL;
const cINT_ZU_ZEICHEN_ARRAY = "123456789abcdefghijklmnopqrstuvwxyz".split('');
const cBASIS = cINT_ZU_ZEICHEN_ARRAY.length;
const BILBAO_VOUCHER_CHARSET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
const BILBAO_VOUCHER_LENGTH = 11;
const BILBAO_VOUCHER_REGEX = new RegExp(`[${BILBAO_VOUCHER_CHARSET}]{${BILBAO_VOUCHER_LENGTH}}`);

export function redeemCode(voucherCode) {
    return new Promise((resolve, reject) => {
        if (voucherCode.toUpperCase().match(BILBAO_VOUCHER_REGEX)) {
            $.getJSON(DRVBundGlobals.ILIAS_BASE_ADDRESS + '/goto.php?bookingCode=' + voucherCode.toUpperCase(), function (data) {
                if ('error' in data) {
                    reject(['Das hat leider nicht geklappt. Bitte probieren Sie es später erneut. ' + data.error]);
                    return;
                }

                resolve(['Sie werden weitergeleitet...', data.target]);
            }).fail(function() {
                reject(['Das hat leider nicht geklappt. Bitte probieren Sie es später erneut.']);
            });
            return;
        }

        if (voucherCode.substring(0, 1) === '#') {
            //Direktlink Option... Codes müssen mit Hashtag beginnen!
            voucherCode = voucherCode.substring(1, voucherCode.length).trim().toUpperCase();

            $.get(CODE_LINK_TABLE_URI, function (html) {
                let tableOuter = $(html).find('.ilTableOuter');
                let tableRows = tableOuter.find('tbody tr');

                tableRows.each(function (index, htmlRow) {
                    let linkCode = $(htmlRow).find('td').eq(0).text().trim().toUpperCase();
                    let linkLink = $(htmlRow).find('td').eq(1).find('a').attr('href').trim();
                    let linkActive = $(htmlRow).find('td').eq(2).text().trim() === 'ja';

                    if (linkCode === voucherCode && linkActive) {
                        resolve(['Sie werden weitergeleitet...',linkLink]);
                    }
                });

                reject(['Der Code ist nicht gültig.']);
            }).fail(function() {
                reject(['Das hat leider nicht geklappt. Bitte probieren Sie es später erneut.']);
            });
        } else {
            //Normale Kursbuchung
            let regexPattern = /^\w{2,}-\w{10}$/;
            let codeSeemsValid = regexPattern.test(voucherCode);
            if (codeSeemsValid) {
                let voucherParts = decodeVoucherCode(voucherCode);
                let url = DRVBundGlobals.ILIAS_BASE_ADDRESS + '/goto.php?target=crs_' + voucherParts[0] + '_rcode' + voucherParts[1] + '&client_id=weiterbildung';

                $.get(url, function (html) {
                    let success = html.search('alert-success');

                    if (success > 0) {
                        resolve(['Kurs erfolgreich gebucht!', url]);
                        return;
                    }

                    reject(['Der Code ist nicht gültig.']);
                }).fail(function() {
                    reject(['Das hat leider nicht geklappt. Bitte probieren Sie es später erneut.']);
                });
            } else {
                reject(['Der Code ist nicht gültig.']);
            }
        }
    })
}

function decodeVoucherCode(vVoucherCode) {
    let vErgebnis = vVoucherCode.split("-");
    if(vErgebnis.length === 2) {
        vErgebnis[0] = decodeCourseID(vErgebnis[0].toString());
        return vErgebnis;
    }
    console.debug("Dekodieren Voucher Code Fehler");
    console.debug("Der Voucher Code entspricht nicht dem Muster XXX-YYYYYYY");
    console.debug("Dekodieren Voucher Code Fehler Ende");
}

function decodeCourseID(vCourseCode) {
    if(typeof vCourseCode!=='string') {
        console.log("Entschluesseln Fehler");
        console.log(vCourseCode + "kann nicht dekodiert werden.");
        console.log("Entschlusseln Fehler Ende");
    }

    let vErgebnis = 0;
    while(vCourseCode) {
        let vPosition = cINT_ZU_ZEICHEN_ARRAY.indexOf(vCourseCode[0]);          //der erste Zeichen des Strings wird betrachtet

        if (vPosition < 0) {
            console.log("Entschluesseln Fehler");
            console.log(vCourseCode[0] + " kann nicht im gültigen Zeichensatz gefunden werden.");
            console.log("Entschlusseln Fehler Ende");
        }
        var vZeichenWertigkeit = vCourseCode.length - 1;                        //je länger der String, desto höher die anfängliche Wertikgeit
        vErgebnis += vPosition * (Math.pow(cBASIS, vZeichenWertigkeit));        //Index des aktuellen Zeichens mal der Basis hoch der Wertigkeit
        vCourseCode = vCourseCode.substring(1);                                 //zum nächsten Zeichen springen indem der String gekürzt wird
    }
    return vErgebnis;
}
